import FooterBar from './FooterBar';

export default FooterBar;
